import { klona } from 'klona';

function stateToResult(state, right) {
    if (state === 'left') {
        return right ? 'lost' : 'won';
    } else if (state === 'right') {
        return right ? 'won' : 'lost';
    } else if (state === 'upcoming') {
        return 'picked';
    } else {
        return null;
    }
}

function stateToMapResult(state) {
    if (state === 'left') {
        return state;
    } else if (state === 'right') {
        return state;
    } else if (state === 'upcoming') {
        return 'picked';
    } else {
        return null;
    }
}

export function mergeCivDraftView(draftView, matchGames, matchRedraftAfter) {
    if (!draftView.host || !draftView.guest) return draftView;

    let result = klona(draftView);

    if (matchRedraftAfter) {
        matchGames = matchGames.slice(matchRedraftAfter);
    }

    matchGames.forEach(game => {
        const hostCiv = game.leftCivs[0];
        if (hostCiv) {
            let hostPick = result.host.find(v => v.action === 'pick' && v.option === hostCiv);
            if (!hostPick) {
                console.log(`Couldn't find ${hostCiv}`, result.host);
            } else {
                hostPick.result = stateToResult(game.state, false);
            }
        }

        const guestCiv = game.rightCivs[0];
        if (guestCiv) {
            let guestPick = result.guest.find(v => v.action === 'pick' && v.option === guestCiv);
            if (!guestPick) {
                console.log(`Couldn't find ${guestCiv}`);
            } else {
                guestPick.result = stateToResult(game.state, true);
            }
        }
    });

    console.log(result);

    return result;
}

export function mergeMapDraftView(draftView, matchGames, matchRedraftAfter) {
    if (!draftView.host || !draftView.guest) return draftView;

    let result = klona(draftView);

    if (matchRedraftAfter) {
        matchGames = matchGames.slice(matchRedraftAfter);
    }

    matchGames.forEach(game => {
        const map = game.map;
        if (map) {
            let hostPick = [...result.host, ...result.guest].find(v => v.action === 'pick' && v.option === map);
            if (!hostPick) {
                console.log(`Couldn't find ${map}`, result.host);
            } else {
                hostPick.result = stateToMapResult(game.state);
            }
        }
    });

    return result;
}
